import { render } from "./UserAuth.vue?vue&type=template&id=6ca67400&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=6ca67400&scoped=true&lang=css"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca67400"]])

export default __exports__